import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=66e34f55&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenha.vue?vue&type=style&index=0&id=66e34f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e34f55",
  null
  
)

export default component.exports